<template>
    <el-button type="primary" @click="handleClick" :disabled="disabled">
        <i :class="iconClass"></i>
        {{buttonText}}
    </el-button>
</template>

<script>
export default {
    name: "RtButton",
    props: {
        type: {
            type: String,
            required: true
        },
        text: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            iconClass: null,
            buttonText: null
        }
    },
    created() {
        this.iconClass = "rt-icon-" + this.type;
        switch (this.type) {
            case "add":
                this.buttonText = this.text || this.$t('BUTTON_ADD');
                break;
            case "print":
                this.buttonText = this.text || this.$t('BUTTON_PRINT');
                break;
            case "confirm":
                this.buttonText = this.text || this.$t('BUTTON_DETERMINE');
                break;
            case "approve-progress":
                this.buttonText = this.text || this.$t('BUTTON_APPROVALPROGRESS');
                break;
            case "delete":
                this.buttonText = this.text || this.$t('BUTTON_DELETE');
                break;
            case "enable":
                this.buttonText = this.text || this.$t('BUTTON_ENABLE');
                break;
            case "disable":
                this.buttonText = this.text || this.$t('BUTTON_DISABLE');
                break;
            case "more":
                this.buttonText = this.text || this.$t('BUTTON_MORE');
                break;
            case "export":
                this.buttonText = this.text || this.$t('BUTTON_EXPORT');
                break;
            case "import":
                this.buttonText = this.text || this.$t('BUTTON_IMPORT');
                break;
            case "submit":
                this.buttonText = this.text || this.$t('BUTTON_SUBMIT');
                break;
            case "revert":
                this.buttonText = this.text || this.$t('BUTTON_WITHDRAW');
                break;
            case "download":
                this.buttonText = this.text || this.$t('BUTTON_DOWNLOAD');
                break;
            case "save":
                this.buttonText = this.text || this.$t('BUTTON_SAVE');
                break;
            default:
                this.iconClass = "";
                this.buttonText = this.text || "<Text>";
                break;
        }
    },
    methods: {
        handleClick() {
            this.$emit("click");
        }
    }
}
</script>


// WEBPACK FOOTER //
// main.vue?1fb35564